import React, { Component, Suspense } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import { Form, Button, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popconfirm } from "antd";

import sortObject from "functions/sort-object";
import SearchSelect from "components/common/SearchSelect";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";

import {
    fetchStores,
    clearStores,
    deleteStore
} from "api/menu/master-files/stores/actions";
import {
    fetchRetailers,
    clearRetailers
} from "api/menu/master-files/retailers/actions";

import {
    closeCustomModal,
    openCustomModal
} from "components/custom/modals";
import _ from "lodash";
import storeTravelChargeTypes from "../../../../data/store-travel-charge-types";

const StoresEditModal = React.lazy(() =>
    import("components/menu/master-files/stores/stores-edit-modal"));
const ImportStoresModal = React.lazy(() =>
    import("components/menu/master-files/stores/import-stores-modal"));

class StoresList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            retailersOptions: [],
            retailersCurrent: null
        };

        this.modalOpen = this.modalOpen.bind(this);
        this.modalImportOpen = this.modalImportOpen.bind(this);
        this.handleSelectRetailer = this.handleSelectRetailer.bind(this);
    }

    componentDidMount () {
        this.props.fetchRetailers(true);
    }

    componentWillReceiveProps (nextProps) {
        const newStates = {};
        if (!this.state.retailersOptions.length && nextProps.retailers.length) {
            const retailersOptions = [];
            const retailersSorted = sortObject(nextProps.retailers, Object.keys(nextProps.retailers).map((value) => parseInt(value, 10)), "name", true);
            retailersSorted.forEach((index) => {
                retailersOptions.push({
                    value: nextProps.retailers[index].id,
                    label: nextProps.retailers[index].name,
                });
            });

            newStates.retailersOptions = retailersOptions;
        }

        this.setState({
            ...newStates,
            stores: nextProps.stores
        });
    }

    componentWillUnmount() {
        this.props.clearRetailers();
        this.props.clearStores();
    }

    modalOpen = (storeId = false) => {
        const modalTitle = storeId !== false ? "Update" : "Create";

        const modalObj = {
            id: `store-${storeId}`,
            modalSettings: {
                size: "lg"
            },
            header: `${modalTitle} Store`,
            children: (
                <Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <StoresEditModal
                        storeId={storeId}
                        retailersOptions={this.state.retailersOptions}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                    />
                </Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    modalImportOpen = () => {
        const modalObj = {
            id: "import-stores",
            modalSettings: {
                size: "lg",
                style: {
                    width: "80%",
                    // maxWidth: "80%",
                }
            },
            header: "Import Stores",
            children: (
                <Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ImportStoresModal
                        retailersOptions={this.state.retailersOptions}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                    />
                </Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    delete = (storeId, storeNumber) => {
        this.props.deleteStore(
            storeId,
            storeNumber,
            () => this.props.fetchStores([this.state.retailersCurrent.value])
        );
    };

    handleSelectRetailer = (retailersCurrent) => {
        this.setState({
            retailersCurrent
        });
        if (retailersCurrent !== null) {
            this.props.fetchStores([retailersCurrent.value]);
        }
    };

    formatAddress = store => {
        const address1 = store && store.address1 ? store.address1 : "";
        const address2 = store && store.address2 ? store.address2 : "";
        return `${address1} ${address2}`;
    };

    render () {
        const {
            stores,
            loading
        } = this.props;

        const {
            retailersOptions,
            retailersCurrent
        } = this.state;

        // address1: "25-27  West Hastings"
        // address2: null
        // city: "Vancouver"
        // cityId: 6135
        // cityTravelCharge: 0
        // cityTravelChargeType: "PerKm"
        // country: "Canada"
        // countryId: 1
        // id: 19845
        // isInactive: false
        // isTravelAssociated: false
        // isTravelRegion: false
        // latitude: 49.2817306518555
        // longitude: -123.105354309082
        // postalCode: "V6B 1G5"
        // province: "British Columbia"
        // provinceId: 2
        // retailer: "ARNA"
        // retailerId: 126
        // storeNumber: 7
        // travelCharge: 0
        // travelChargeType: "PerKm"

        const classNameFlexCenter = "d-flex justify-content-center align-items-center";
        const columns = [
            {
                Header: "Store #",
                accessor: "storeNumber",
                id: "storeNumber",
                width: 70
            },
            {
                Header: "Name",
                id: "name",
                accessor: "name",
                style: {
                    whiteSpace: "unset"
                },
            },
            {
                Header: "Address",
                id: "address",
                style: {
                    whiteSpace: "unset"
                },
                accessor: original => original.address1 + original.address2,
                Cell: ({ original }) => this.formatAddress(original)
            },
            {
                Header: "City",
                accessor: "city",
                id: "city"
            },
            {
                Header: "Province",
                accessor: "province",
                id: "province"
            },
            {
                Header: "Postal Code",
                accessor: "postalCode",
                id: "postalCode"
            },

            {
                Header: "Is Travel Associated",
                id: "isTravelAssociated",
                accessor: original => (original.isTravelAssociated ? "Yes" : "No"),
                Cell: ({ original }) => (original.isTravelAssociated ? "Yes" : "No"),
                className: classNameFlexCenter,
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Yes",
                            NO: "No"
                        }}
                    />
                )
            },
            {
                Header: "Travel Charge Type",
                accessor: "travelChargeType",
                id: "travelChargeType",
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%", height: "100%" }}
                        value={filter ? filter.value : ""}
                    >
                        <option value="">Show All</option>
                        {Object.keys(storeTravelChargeTypes).map(value => (
                            <option key={value} value={value}>
                                {storeTravelChargeTypes[value]}
                            </option>
                        ))}
                    </select>
                ),
                Cell: ({ original }) => storeTravelChargeTypes[original.travelChargeType]
            },
            {
                Header: "Travel Charge",
                accessor: "travelCharge",
                id: "travelCharge",
                Filter: ({ filter, onChange }) => {
                    const travelChargeArr = [];
                    this.props.stores.forEach((value) => {
                        travelChargeArr.push(value.travelCharge);
                    });
                    return (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%", height: "100%" }}
                            value={filter ? filter.value : ""}
                        >
                            <option value="">Show All</option>
                            {_.uniq(travelChargeArr).map((value, index) => (
                                <option key={index} value={value}>
                                    {value}
                                </option>
                            ))}
                        </select>
                    );
                }
            },

            {
                Header: "Active?",
                id: "isInactive",
                accessor: original => (original.isInactive ? "NO" : "YES"),
                Cell: ({ original }) => (original.isInactive ? "NO" : "YES"),
                className: classNameFlexCenter,
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Active",
                            NO: "Inactive"
                        }}
                    />
                )
            },
            {
                Header: "Actions",
                id: "actions",
                className: classNameFlexCenter,
                Cell: ({ original }) => (
                    <ButtonGroup>
                        <Button size="sm" onClick={() => this.modalOpen(original.id)}>
                            <FontAwesomeIcon icon="pen" title="Update" />
                        </Button>
                        <Popconfirm
                            title={`Delete "${original.storeNumber}"?`}
                            onConfirm={() => this.delete(original.id, original.storeNumber)}
                            placement="bottomRight"
                            okText="Yes"
                            cancelText="Cancel"
                        >
                            <Button variant="danger" size="sm">
                                <FontAwesomeIcon icon="times" />
                            </Button>
                        </Popconfirm>
                    </ButtonGroup>
                ),
                filterable: false,
                width: 100
            }
        ];

        // id: 7966
        // storeNumber: 7222

        // address1: "12749 20th Avenue, Box 358"
        // address2: ""
        // postalCode: "T0K 0E0"

        // country: "Canada"
        // countryId: 1

        // province: "Alberta"
        // provinceId: 1

        // city: "Baltimore"
        // cityId: 551

        // code: "7222"
        // isInactive: false
        // latitude: 49.6076583862305
        // longitude: -114.436981201172
        // retailerId: 55
        // https://www.google.com/maps/search/?api=1&query=58.698017,-152.522067

        return (
            <div className="dashboard">
                <h3 className="mb-4">Stores</h3>

                <div className="mb-5">
                    <Form.Group>
                        <Form.Label>Retailer</Form.Label>
                        <SearchSelect
                            options={retailersOptions}
                            isLoading={false}
                            isClearable={false}
                            isSearchable={true}
                            value={retailersCurrent}
                            onChange={this.handleSelectRetailer}
                        />
                    </Form.Group>
                </div>

                <ReactTable
                    data={stores}
                    headerClassName="table-header"
                    columns={columns}
                    defaultPageSize={20}
                    pageSizeOptions={[10, 20, 50, 100]}
                    resizable
                    className="-striped -highlight"
                    loading={loading}
                    filterable
                    defaultFilterMethod={filterCaseInsensitive}
                    defaultSorted={[{
                        id: "storeNumber",
                        desc: false
                    }]}
                    defaultFiltered={[{
                        id: "isInactive",
                        value: "YES"
                    }]}
                    getNoDataProps = {() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                    style={{
                        height: "calc(100vh - 300px)",
                    }}
                />

                <div className="d-flex justify-content-between mt-4 mb-4">
                    <div>
                        <Button variant="info" onClick={() => this.modalImportOpen()}>
                            Import Stores
                        </Button>
                        <Link
                            className="btn btn-warning ml-2"
                            to="/files/import-stores-template.csv"
                            target="_blank"
                            download
                        >
                            Download Import Template
                        </Link>
                    </div>

                    <Button className="ml-2" variant="primary" onClick={() => this.modalOpen()}>
                        Add New Store
                    </Button>
                </div>

            </div>
        );
    }
}

StoresList.propTypes = {
    fetchRetailers: PropTypes.func.isRequired,
    fetchStores: PropTypes.func.isRequired,
    deleteStore: PropTypes.func.isRequired,

    retailers: PropTypes.array.isRequired,
    stores: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    retailers: state.retailers.retailers,
    stores: state.stores.stores,

    loading: state.stores.loading
});

const mapStateToDispatch = dispatch => ({
    fetchRetailers: bindActionCreators(fetchRetailers, dispatch),
    clearRetailers: bindActionCreators(clearRetailers, dispatch),
    fetchStores: bindActionCreators(fetchStores, dispatch),
    clearStores: bindActionCreators(clearStores, dispatch),
    deleteStore: bindActionCreators(deleteStore, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(StoresList);
